<!-- stream list item row -->
<div
  class="flex gap-[15px] items-center w-full group bg-white rounded"
  [class.cursor-grab]="!isDragging && !dragDisabled"
  [class.cursor-grabbing]="isDragging"
>
  <!-- drag handle (hover) / order number (default) -->
  @if (!dragDisabled) {
    <div
      class="drag-handle w-[15px] shrink-0 flex items-center justify-center relative"
      [class.drag-handle-active]="!dragDisabled"
    >
      <fa-icon
        [icon]="'grip-vertical'"
        class="absolute transition-opacity duration-200 opacity-0 text-black/20"
      ></fa-icon>
      <span
        class="text-lg font-bold text-center transition-opacity duration-200 pointer-events-none"
      >{{ index + 1 }}</span>
    </div>
  }

  <!-- stream card -->
  <div class="flex flex-1 items-center gap-[15px] bg-gray-hover rounded p-2 min-w-0">
    <!-- thumbnail or placeholder -->
    @if (logoUrl) {
      <img
        [src]="logoUrl"
        [alt]="streamName"
        class="w-[107px] h-12 rounded object-cover shrink-0"
      />
    } @else {
      <div class="w-[107px] h-12 rounded bg-gray-lightest flex items-center justify-center shrink-0">
        <fa-icon [icon]="'music'" class="text-gray-darkest"></fa-icon>
      </div>
    }

    <!-- name + type -->
    <div class="flex flex-col justify-center min-w-0 flex-1">
      <span class="font-bold text-lg truncate">{{ streamName }}</span>
      <span class="text-base opacity-70 truncate">{{ streamTypeLabel }}</span>
    </div>

    <!-- action button (visible on hover) -->
    <button
      class="opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center w-11 h-10 rounded bg-white shrink-0 cursor-pointer"
      [matMenuTriggerFor]="actionMenu"
      (mousedown)="$event.stopPropagation()"
    >
      <fa-icon [icon]="'ellipsis-v'" class="text-base"></fa-icon>
    </button>

    <mat-menu #actionMenu="matMenu" class="stream-action-menu">
      <!-- edit -->
      <button mat-menu-item (click)="onEdit()">
        <fa-icon [icon]="'pen'"></fa-icon>
        {{ 'stream-list-item.edit' | translate }}
      </button>

      <!-- reorder -->
      @if (!isFirst || !isLast) {
        <div class="menu-divider"></div>

        @if (!isFirst) {
          <button mat-menu-item (click)="onMoveToTop()">
            <fa-icon [icon]="'angles-up'"></fa-icon>
            {{ 'stream-list-item.move-to-top' | translate }}
          </button>
        }

        @if (!isLast) {
          <button mat-menu-item (click)="onMoveToBottom()">
            <fa-icon [icon]="'angles-down'"></fa-icon>
            {{ 'stream-list-item.move-to-bottom' | translate }}
          </button>
        }
      }

      <!-- separator + delete -->
      @if (!isLastStream) {
        <div class="menu-divider"></div>

        <button mat-menu-item class="menu-item-danger" (click)="onDelete()">
          <fa-icon [icon]="'trash'"></fa-icon>
          {{ 'stream-list-item.delete' | translate }}
        </button>
      }
    </mat-menu>
  </div>
</div>
